import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as o, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconBookOpen",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M.5 1.5A.5.5 0 0 1 1 1h3a2.5 2.5 0 0 1 2 1 2.5 2.5 0 0 1 2-1h3a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-.5.5H7.5a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 1 1 0 0 0-1-1H1A.5.5 0 0 1 .5 9V1.5Zm5 2v5.268a2 2 0 0 0-1-.268h-3V2H4a1.5 1.5 0 0 1 1.5 1.5Zm2 5a2 2 0 0 0-1 .268V3.5A1.5 1.5 0 0 1 8 2h2.5v6.5h-3Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function h(a, u, i, p, f, e) {
  return o(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--book-open"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Book Open",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const k = /* @__PURE__ */ l(s, [["render", h]]);
export {
  k as default
};
//# sourceMappingURL=book-open.js.map
